import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'VentureModuleOverview',
  props: {
    value: {
      type: Object,
      required: true
    },
    number: {
      type: Number,
      required: false,
      default: null
    },
    bookedModules: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var iconMapping = {
      'Company information': {
        active: require('~/assets/icons/company-info/blue.svg/'),
        inactive: require('~/assets/icons/company-info/grey.svg')
      },
      'ESG assessment': {
        active: require('~/assets/icons/esg-assessment/blue.svg'),
        inactive: require('~/assets/icons/esg-assessment/grey.svg')
      },
      'KPI reporting': {
        active: require('~/assets/icons/metrics/blue.svg'),
        inactive: require('~/assets/icons/metrics/grey.svg')
      },
      'Impact goals': {
        active: require('~/assets/icons/impact-goals/blue.svg'),
        inactive: require('~/assets/icons/impact-goals/grey.svg')
      },
      'Impact scoring': {
        active: require('~/assets/icons/impact-goals/blue.svg'),
        inactive: require('~/assets/icons/impact-goals/grey.svg')
      },
      'GHG reduction potential': {
        active: require('~/assets/icons/ghg-emissions/blue.svg/'),
        inactive: require('~/assets/icons/ghg-emissions/grey.svg')
      }
    };
    var isBooked = computed(function () {
      var _props$bookedModules;
      return (_props$bookedModules = props.bookedModules) === null || _props$bookedModules === void 0 ? void 0 : _props$bookedModules.some(function (m) {
        var _props$value, _props$value$showForM;
        return (_props$value = props.value) === null || _props$value === void 0 ? void 0 : (_props$value$showForM = _props$value.showForModules) === null || _props$value$showForM === void 0 ? void 0 : _props$value$showForM.includes(m);
      });
    });
    var isDisabled = computed(function () {
      return props.value.upcoming || !isBooked.value;
    });
    return {
      __sfc: true,
      props: props,
      iconMapping: iconMapping,
      isBooked: isBooked,
      isDisabled: isDisabled,
      renderMarkdown: renderMarkdown
    };
  }
});